import React, { useState, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
} from '../actions';
import {
  SIDEBAR_ITEMS,
} from '../screens/Dashbord/constants/items';
import { hasPermission } from '../utils/common';
import Logo from '../assets/images/blombos_cropped.jpeg';
import UserProfile from './userProfile';

const NavbarMenu = (props) => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    props.tostMessageLoad(true);
    const { activeKey } = props;
    activeMenutabwhenNavigate('/' + activeKey);
  }, []);

  const activeMenutabwhenNavigate = (activeKey) => {
    if (
      activeKey === '/dashboard' ||
      activeKey === '/demographic' ||
      activeKey === '/ioT'
    ) {
      activeMenutabContainer('dashboard');
    } else if (
      activeKey === '/patient-form' ||
      activeKey === '/adduser' ||
      activeKey === '/appcalendar' ||
      activeKey === '/appcontact' ||
      activeKey === '/apptaskbar' ||
      activeKey === '/patient-form' ||
      activeKey === '/view-fet-patients'
    ) {
      activeMenutabContainer('AppContainer');
    } else if (
      activeKey === '/filemanagerdashboard' ||
      activeKey === '/filedocuments' ||
      activeKey === '/filemedia'
    ) {
      activeMenutabContainer('FileManagerContainer');
    } else if (
      activeKey === '/blognewpost' ||
      activeKey === '/bloglist' ||
      activeKey === '/blogdetails'
    ) {
      activeMenutabContainer('BlogContainer');
    } else if (
      activeKey === '/uitypography' ||
      activeKey === '/uitabs' ||
      activeKey === '/uibuttons' ||
      activeKey === '/bootstrapui' ||
      activeKey === '/uiicons' ||
      activeKey === '/uinotifications' ||
      activeKey === '/uicolors' ||
      activeKey === '/uilistgroup' ||
      activeKey === '/uimediaobject' ||
      activeKey === '/uimodal' ||
      activeKey === '/uiprogressbar'
    ) {
      activeMenutabContainer('UIElementsContainer');
    } else if (
      activeKey === '/widgetsdata' ||
      activeKey === '/widgetsweather' ||
      activeKey === '/widgetsblog' ||
      activeKey === '/widgetsecommers'
    ) {
      activeMenutabContainer('WidgetsContainer');
    } else if (activeKey === '/login') {
      activeMenutabContainer('WidgetsContainer');
    } else if (
      activeKey === '/teamsboard' ||
      activeKey === '/profilev2page' ||
      activeKey === '/helperclass' ||
      activeKey === '/searchresult' ||
      activeKey === '/invoicesv2' ||
      activeKey === '/invoices' ||
      activeKey === '/pricing' ||
      activeKey === '/timeline' ||
      activeKey === '/profilev1page' ||
      activeKey === '/blankpage' ||
      activeKey === '/imagegalleryprofile' ||
      activeKey === '/projectslist' ||
      activeKey === '/maintanance' ||
      activeKey === '/testimonials' ||
      activeKey === '/faqs'
    ) {
      activeMenutabContainer('PagesContainer');
    } else if (
      activeKey === '/formvalidation' ||
      activeKey === '/basicelements'
    ) {
      activeMenutabContainer('FormsContainer');
    } else if (activeKey === '/tablenormal') {
      activeMenutabContainer('TablesContainer');
    } else if (activeKey === '/echart') {
      activeMenutabContainer('chartsContainer');
    } else if (activeKey === '/leafletmap') {
      activeMenutabContainer('MapsContainer');
    }
  };

  const activeMenutabContainer = (id) => {
    setActiveDropdown((prevActiveDropdown) =>
      prevActiveDropdown === id ? null : id,
    );
    var parents = document.getElementById('main-menu');
    var activeMenu = document.getElementById(id);
    if (parents && activeMenu) {
      for (let index = 0; index < parents.children.length; index++) {
        if (parents.children[index].id !== id) {
          try {
            parents.children[index].classList.remove('active');
            parents.children[index].children[1].classList.remove('in');
          } catch (e) {
            console.log('error', e);
          }
        }
      }
    }
    setTimeout(() => {
      try {
        activeMenu.classList.toggle('active');
        activeMenu.children[1].classList.toggle('in');
      } catch (e) {}
    }, 10);
  };

  const handleLogoutClick = () => {
    localStorage.clear();
    navigate('/');
  };

  const handleSidebarToggle = () => {
    setIsCollapsed(!isCollapsed);
    props.setIsSidebarVisible(!isCollapsed);
    props.onPressSideMenuToggle();
  };

  const {
    themeColor,
    toggleNotification,
    toggleEqualizer,
    sideMenuTab,
    isToastMessage,
    activeKey,
    permissionsMap,
  } = props;

  document.body.classList.add(themeColor);

  return (


      <div
        id="left-sidebar"
        className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}
        style={{
          zIndex: 9,
          backgroundColor: '#fff',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
          width: isCollapsed ? '80px' : '250px',
        }}
      >
              <nav
        className="navbar navbar-fixed-top"
        id="left-sidebar-transitioned"
        style={{
          height: '87px',
          width: isCollapsed ? '80px' : '250px',
        }}
      >
        <div
          className="container-fluid"
          style={{ justifyContent: 'flex-start' }}
        >
          <div className="navbar-btn">
            <button
              className="btn-toggle-offcanvas"
              onClick={handleSidebarToggle}
            >
              <i className="lnr lnr-menu fa fa-bars"></i>
            </button>
          </div>
          {!isCollapsed && (
            <div className="navbar-brand">
              <Link to="/">
                <img
                  src={Logo}
                  alt="Blomboss Logo"
                  style={{
                    width: 'auto',
                    maxHeight: '55px',
                    height: 'auto',
                  }}
                />
              </Link>
            </div>
          )}
        </div>
      </nav>
        <div className="sidebar-scroll">
          <UserProfile isCollapsed={isCollapsed} />
          <div className="tab-content p-l-0 p-r-0">
            <div
              className={sideMenuTab[0] ? 'tab-pane active show' : 'tab-pane'}
              id="menu"
            >
              <Nav id="left-sidebar-nav" className="sidebar-nav">
                <ul id="main-menu" className="metismenu">
                  {SIDEBAR_ITEMS.filter((item) =>
                    item.permissionsRequired
                      ? hasPermission(permissionsMap, item.permissionsRequired)
                      : true,
                  ).map((item) => (
                    <li
                      key={item.activeIdentifier}
                      className={
                        activeDropdown === item.activeIdentifier ? 'active' : ''
                      }
                      id={item.activeIdentifier}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(item.url);
                        activeMenutabContainer(item.activeIdentifier);
                      }}
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <i className={item.iconClassName}></i>{' '}
                        {!isCollapsed && <span>{item.title}</span>}
                      </a>
                    </li>
                  ))}
                </ul>
              </Nav>
            </div>
          </div>
        </div>
      </div>
  );
};

NavbarMenu.propTypes = {
  addClassactive: PropTypes.array.isRequired,
  addClassactiveChild: PropTypes.array.isRequired,
  addClassactiveChildApp: PropTypes.array.isRequired,
  addClassactiveChildFM: PropTypes.array.isRequired,
  addClassactiveChildBlog: PropTypes.array.isRequired,
  addClassactiveChildUI: PropTypes.array.isRequired,
  addClassactiveChildWidgets: PropTypes.array.isRequired,
  addClassactiveChildAuth: PropTypes.array.isRequired,
  addClassactiveChildPages: PropTypes.array.isRequired,
  addClassactiveChildForms: PropTypes.array.isRequired,
  addClassactiveChildTables: PropTypes.array.isRequired,
  addClassactiveChildChart: PropTypes.array.isRequired,
  addClassactiveChildMaps: PropTypes.array.isRequired,
  themeColor: PropTypes.string.isRequired,
  generalSetting: PropTypes.array.isRequired,
  toggleNotification: PropTypes.bool.isRequired,
  toggleEqualizer: PropTypes.bool.isRequired,
  permissionsMap: PropTypes.object.isRequired,
};

const mapStateToProps = ({ navigationReducer, loginReducer }) => {
  const {
    addClassactive,
    addClassactiveChild,
    addClassactiveChildApp,
    addClassactiveChildFM,
    addClassactiveChildBlog,
    addClassactiveChildUI,
    addClassactiveChildWidgets,
    addClassactiveChildAuth,
    addClassactiveChildPages,
    addClassactiveChildForms,
    addClassactiveChildTables,
    addClassactiveChildChart,
    addClassactiveChildMaps,
    themeColor,
    generalSetting,
    toggleNotification,
    toggleEqualizer,
    menuProfileDropdown,
    sideMenuTab,
    isToastMessage,
  } = navigationReducer;

  const { permissionsMap } = loginReducer;
  return {
    addClassactive,
    addClassactiveChild,
    addClassactiveChildApp,
    addClassactiveChildFM,
    addClassactiveChildBlog,
    addClassactiveChildUI,
    addClassactiveChildWidgets,
    addClassactiveChildAuth,
    addClassactiveChildPages,
    addClassactiveChildForms,
    addClassactiveChildTables,
    addClassactiveChildChart,
    addClassactiveChildMaps,
    themeColor,
    generalSetting,
    toggleNotification,
    toggleEqualizer,
    menuProfileDropdown,
    sideMenuTab,
    isToastMessage,
    permissionsMap,
  };
};

export default connect(mapStateToProps, {
  onPressDashbord,
  onPressDashbordChild,
  onPressThemeColor,
  onPressGeneralSetting,
  onPressNotification,
  onPressEqualizer,
  onPressSideMenuToggle,
  onPressMenuProfileDropdown,
  onPressSideMenuTab,
  tostMessageLoad,
})(NavbarMenu);